define((require) => {
    "use strict";

    const _                                         = require("underscore");
    const Backbone                                  = require("backbone");
    const ImprovedView                              = require("editor/zbone/ImprovedView");

    /**
     *
     * @class CreateNewExperienceView
     *
     */
    return ImprovedView.extend({

        template: _.template("<div class='text'><%= labelUnescaped %></div>"),

        _onClick: () => {},

        _labelUnescaped: "",

        // We need a model due to the delete code in the chunking collection.
        model: new Backbone.Model(),

        initialize(options) {
            const {label = this._labelUnescaped, onClick = this._onClick} = options;
            this._labelUnescaped = label;
            this._onClick = onClick;
        },

        templateHelpers: function() {
            return {
                labelUnescaped: this._labelUnescaped
            };
        },

        tagName: "a",

        className: function() {
            const baseClassName = "create-experience-content-item";
            let className;
            if (this.options && this.options.additionalClassName) {
                className = this.options.additionalClassName;
            }

            return !className ? baseClassName : `${baseClassName} ${className}`;
        },

        ui: {
            addButton: ".text"
        },

        events: {
            "click @ui.addButton": function(event) {
                this._onClick(event);
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/CreateNewExperienceView.js